export function truncate(str, n) {
  return str && str.length > n ? str.slice(0, n) + "..." : str;
}
